import React from 'react';
import { motion } from 'framer-motion';
import { Calculator, MessageCircle, Palette, Zap } from 'lucide-react';
const features = [{
  icon: Calculator,
  title: 'Calculadora de Precios e Inventario',
  description: 'Nuestra herramienta estrella. Fija tus costos en dólares y calcula automáticamente cuánto cobrar en Bolívares (BCV/Paralelo). Controla tu stock y tus ganancias reales sin errores.'
}, {
  icon: Palette,
  title: '100 Plantillas Pro (Canva)',
  description: 'Diseños listos para vender. Transmiten autoridad para que puedas cobrar lo que vales. Solo arrastra tus fotos y publica en minutos desde tu celular.'
}, {
  icon: MessageCircle,
  title: 'Sistema de Cierre (WhatsApp)',
  description: 'Guiones exactos de "copiar y pegar" para responder cuando preguntan el "Precio". Convierte a los curiosos en compradores reales sin rogarles.'
}, {
  icon: Zap,
  title: 'Implementación HOY Mismo',
  description: 'Sin cursos largos. Recibes el archivo, lo abres en Excel y empiezas a poner orden en tu negocio de inmediato. Cero complicaciones técnicas.'
}];
export function Features() {
  return <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden w-full overflow-x-hidden relative z-10" data-id="element-55">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-57">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-green-500/10 border border-green-500/20 text-green-400 text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-58">
            📦 El Arsenal Completo
          </div>

          <h2 className="font-heading text-3xl md:text-5xl font-black text-white mb-6 leading-tight tracking-tight" data-id="element-59">
            Deja de improvisar. Usa el sistema de los que{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-60">
              SÍ venden.
            </span>
          </h2>

          <p className="text-lg text-gray-400 mb-10 leading-relaxed font-light max-w-xl" data-id="element-61">
            No necesitas pagarle $300 al mes a una agencia de marketing. Con
            este Toolkit tienes todo bajo tu control, directamente desde tu
            celular.
          </p>

          <div className="space-y-8" data-id="element-62">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-5 group" data-id="element-63">
                <div className="mt-1 flex-shrink-0 w-12 h-12 rounded-xl bg-[#111] border border-white/10 flex items-center justify-center group-hover:bg-cyan-500/10 group-hover:border-cyan-500/30 transition-all duration-300" data-id="element-64">
                  <feature.icon className="w-6 h-6 text-cyan-400 group-hover:text-green-400 transition-colors duration-300" data-id="element-65" />
                </div>
                <div data-id="element-66">
                  <h3 className="font-heading text-xl font-bold text-white mb-2 tracking-tight group-hover:text-cyan-400 transition-colors duration-300" data-id="element-67">
                    {feature.title}
                  </h3>
                  <p className="text-gray-400 leading-relaxed text-sm md:text-base" data-id="element-68">
                    {feature.description}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 40
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative lg:ml-10 mt-10 lg:mt-0" data-id="element-69">
          <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/10 to-green-500/10 rounded-[40px] blur-3xl transform rotate-3" data-id="element-70" />

          <div className="relative w-full max-w-md md:max-w-full aspect-square bg-[#0a0a0a] border border-cyan-500/20 rounded-[40px] p-4 shadow-[0_0_60px_rgba(34,211,238,0.15)] overflow-hidden group hover:border-cyan-500/40 hover:shadow-[0_0_80px_rgba(34,211,238,0.25)] transition-all duration-500 mx-auto lg:mx-0" data-id="element-71">
            <img src="https://cdn.shopify.com/s/files/1/0708/2174/0632/files/dashboard-features.jpg?v=1773383848" alt="Toolkit Pro Digital Control Dashboard visualization" className="w-full h-full object-cover rounded-[30px] transform group-hover:scale-105 transition-transform duration-700 ease-out" data-id="element-72" />

            <div className="absolute inset-4 rounded-[30px] border border-white/10 bg-gradient-to-t from-black/40 to-transparent pointer-events-none group-hover:border-cyan-500/40 transition-colors duration-500" data-id="element-73" />
          </div>
        </motion.div>
      </div>
    </section>;
}